import { IApplicationState } from 'shared/types/redux';

export const selectIsAuthorizedModalOpen = (state: IApplicationState): boolean => state.landing.authorizedModal.isOpen;
